<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-cancel="hide()"
    :closeText="$t('Close')"
    maxWidth="60%"
    :showConfirmButton="false"
  >
    <v-card class="pb-3 mb-3">
      <v-card-text>
        <v-text-field
          v-bind:label="$t('Search')"
          v-model="searchText"
          @input="serachFields"
        ></v-text-field>
      </v-card-text>
    </v-card>
    <v-card class="pt-0 mt-0">
      <v-card-text>
        <v-row justify="center" align="center" v-if="loading" height="300px">
          <div class="text-center">
            <div>
              <v-progress-circular
                class="my-4"
                :size="50"
                width="5"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
            <p class="display-1">{{ $t("Loading") }}...</p>
          </div>
        </v-row>
        <v-simple-table dense v-if="!loading" height="300px">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $t("ContentType") }}</th>
                <th class="text-left">{{ $t("Code") }}</th>
                <th class="text-left">{{ $t("Name") }}</th>
                <th class="text-left">{{ $t("Type") }}</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(field, index) in defFields" :key="index">
                <td>{{ field.contentTypeName }}</td>
                <td>{{ field.code }}</td>
                <td>{{ field.name }}</td>
                <td>{{ getFieldType(field.type) }}</td>
                <td>
                  <v-btn icon @click="select(field)">
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </base-modal>
</template>
<script>
import ContentTypeService from "@/services/ContentTypeService";
import ContentTypeField from "@/ecm/models/contentType/ContentTypeField";
import User from "@/ecm/models/User";
import Utils from "@/ecm/common/Utils";
import FieldType from "@/ecm/variables/FieldType";

export default {
  data() {
    return {
      loading: false,
      searchText: "",
      defFields: [],
      modal: {
        title: this.$t("Search"),
        key: "searchFieldModal",
      },
      open: false,
    };
  },
  methods: {
    serachFields() {
      this.loading = true;

      return ContentTypeService.searchFields(this.searchText)
        .then((data) => {
          this.defFields = data.map((dto) => new ContentTypeField(dto));
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.loading = false;
        });
    },
    select(field) {
      this.$emit("on-select", Utils.object.toJS(field));
      this.hide();
    },
    getFieldType(type) {
      switch (type) {
        case FieldType.String:
          return this.$t("FieldTypeString");
        case FieldType.DateTime:
          return this.$t("FieldTypeDate");
        case FieldType.Numeric:
          return this.$t("FieldTypeNumeric");
        case FieldType.StaticList:
          return `${this.$t("FieldTypeList")} (${this.$t("Static")})`;
        case FieldType.DynamicList:
          return `${this.$t("FieldTypeList")} (${this.$t("ExternalTables")})`;
        case FieldType.DynamicTableList:
          return `${this.$t("FieldTypeList")} (${this.$t("InternalTables")})`;
      }
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>